const getOgImageLink = (pageTitle) =>
  `https://og-image-j5av8lms1-remoteteam.vercel.app/` +
  `${encodeURIComponent(pageTitle)}.png?theme=dark` +
  `&fontSize=110px` +
  `&images=https://imagedelivery.net/m_TmrpCr2ia-yFj8fl_8Zw/73e03bb6-31c7-459a-d6fc-fb4a2e46a700/avatar`;

module.exports = getOgImageLink;
